// this file is automatically generated by git.revision.js script
export const versions = { revision: 'dc50bccea5' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = 'dc50bccea5';
